import { render, staticRenderFns } from "./ExportPdfReceipt.vue?vue&type=template&id=73d6c0ba"
import script from "./ExportPdfReceipt.vue?vue&type=script&lang=ts"
export * from "./ExportPdfReceipt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports